export default __webpack_public_path__ + "static/media/M12 - Bold Hermit.bc607660.png";